module.exports = __webpack_public_path__ + "static/media/SplunkEnterpriseSystemAdmin.6d78c3be.png";